enum trackingAttributes {
  thief = 'theft',
  damage = 'fall_impact_damage',
  droplet = 'water_damage',
  lightning = 'fire_damage',
  money = 'deductible',
  truck_small = 'costs',
  wrench = 'manufacturing_errors'
}

export function getInsuranceAttributeTrackingContent({
  iconDescription
}: {
  iconDescription: string;
}): trackingAttributes | null {
  function mapContent(iconDescription: string): trackingAttributes | null {
    const iconDescriptionMap = new Map([
      ['thief', trackingAttributes.thief],
      ['damage', trackingAttributes.damage],
      ['droplet', trackingAttributes.droplet],
      ['lightning', trackingAttributes.lightning],
      ['circleeuro', trackingAttributes.money],
      ['money', trackingAttributes.money],
      ['truck_small', trackingAttributes.truck_small],
      ['wrench', trackingAttributes.wrench]
    ]);
    return iconDescriptionMap.get(iconDescription.toLowerCase()) || null;
  }

  return mapContent(iconDescription);
}
